import { revertDeviceModel } from '@/shared/lib';
import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { MaintenanceDevicesQuery, MaintenanceDevicesQueryVariables } from '@/shared/api';
import MAINTENANCE_DEVICES_QUERY from '../queries/maintenanceDevices';

/**
 * Loads the devices currently under maintenance for the call-center device list. Deep-clones the filter and rewrites its model to the legacy identifier, queries MAINTENANCE_DEVICES_QUERY with the filter and page limit, and throws the first GraphQL error message when no devices came back.
 *
 * @param filter - Filter criteria, whose model is converted to its legacy name.
 * @param limit - Maximum number of records to return.
 * @returns Promise resolving to the maintenance devices.
 */
const fetchMaintenanceDevices = async (
  filter: MaintenanceDevicesQueryVariables['filter'],
  limit = 10,
): Promise<MaintenanceDevicesQuery['callCenterDevices']> => {
  const client = createClient();
  const clonedFilter = _.cloneDeep(filter);
  if (!_.isEmpty(clonedFilter)) {
    clonedFilter.model = revertDeviceModel(clonedFilter.model);
  }
  const result = await client.query<MaintenanceDevicesQuery, MaintenanceDevicesQueryVariables>({
    query: MAINTENANCE_DEVICES_QUERY,
    variables: {
      filter: clonedFilter,
      limit,
    },
  });
  const { data, errors } = result;
  const { callCenterDevices } = data;
  if (_.isNil(callCenterDevices) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return callCenterDevices;
};

export default fetchMaintenanceDevices;
